import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Chip from '@material-ui/core/Chip';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import api from "../../services/api";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  container: { paddingTop: theme.spacing(4), paddingBottom: theme.spacing(4) },
  title: { marginBottom: theme.spacing(3), color: '#2c3e50', fontWeight: 'bold' },
  filterPaper: { padding: theme.spacing(2), marginBottom: theme.spacing(3), borderRadius: '8px' },
  tableContainer: { boxShadow: '0 4px 6px rgba(0,0,0,0.05)', borderRadius: '8px' },
  tableHeader: { backgroundColor: '#f4f6f9' },
  headerCell: { fontWeight: 'bold', color: '#34495e' },
  row: { '&:nth-of-type(odd)': { backgroundColor: '#fafafa' } },
  badge: { fontWeight: 'bold', fontSize: '14px' },
  button: { height: '100%' }
}));

export default function CompletedByAnalyst() {
  const classes = useStyles();
  
  const hoje = new Date().toISOString().split('T')[0];
  
  const [startDate, setStartDate] = useState(hoje);
  const [endDate, setEndDate] = useState(hoje);
  const [analistas, setAnalistas] = useState([]);

  const fetchDados = async () => {
    try {
      // 🟢 ALTERADO: Agora aponta para a rota da query complexa com meta
      const { data } = await api.get("/tickets-meta", {
        params: { startDate, endDate }
      });
      setAnalistas(data);
    } catch (err) {
      toast.error("Erro ao carregar dados do histórico com metas.");
    }
  };

  useEffect(() => {
    fetchDados();
  }, []);

  return (
    <Container maxWidth="lg" className={classes.container}>
      <Typography variant="h5" component="h2" className={classes.title}>
        Tickets Finalizados por Analista
      </Typography>

      <Paper className={classes.filterPaper} variant="outlined">
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} sm={4}>
            <TextField
              label="Data Início"
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              label="Data Fim"
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={fetchDados}
              fullWidth
            >
              Filtrar Histórico
            </Button>
          </Grid>
        </Grid>
      </Paper>

      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table aria-label="tabela de finalizados">
          <TableHead className={classes.tableHeader}>
            <TableRow>
              <TableCell className={classes.headerCell}>Analista</TableCell>
              <TableCell align="center" className={classes.headerCell}>Total de Atendimentos Finalizados No Periodo</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {analistas.length === 0 ? (
              <TableRow>
                <TableCell colSpan={2} align="center" style={{ color: '#7f8c8d' }}>
                  Nenhum ticket finalizado com critérios de meta encontrado neste período.
                </TableCell>
              </TableRow>
            ) : (
              analistas.map((analista) => (
                <TableRow key={analista.id} className={classes.row}>
                  <TableCell component="th" scope="row" style={{ fontWeight: 500 }}>
                    {analista.nome}
                  </TableCell>
                  <TableCell align="center">
                    <span className={classes.badge}>
                      <Chip 
                        label={analista.qtdTickets} // Mantém qtdTickets vindo do backend
                        color="primary"
                      />
                    </span>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
}